import React from "react";

export const getChildren = (alias, files) => {
    const findItem = (alias, items) => {
        for (let item of items) {
            if (item.alias === alias) {
                return item;
            }
            if (item.isFolder && item.children) {
                const found = findItem(alias, item.children);
                if (found) {
                    return found;
                }
            }
        }
        return null;
    };

    const item = findItem(alias, files);
    return item ? item.children || [] : [];
};


export const getParents = (alias, files) => {
    const findItemWithParents = (alias, items, parents = []) => {
        for (let item of items) {
            if (item.alias === alias) {
                return parents;
            }
            if (item.isFolder && item.children) {
                const found = findItemWithParents(alias, item.children, [...parents, item]);
                if (found) {
                    return found;
                }
            }
        }
        return null;
    };

    return findItemWithParents(alias, files);
};

export const  updateFileWithHash = (files, selectedFileHash, newChildren) => {
    return files.map(file => {
        if (file.hash === selectedFileHash) {
            return { ...file, children: newChildren };
        } else if (file.children) {
            return { ...file, children: updateFileWithHash(file.children, selectedFileHash, newChildren) };
        }
        return file;
    });
}

export const handleIcon = (file) => {
    if (file.isFolder) {
        return (
            <span className="folder-icon">
                <em className="fa fa-folder"></em>
            </span>
        );
    }

    if (file.tmb) {
        return (
            <div className="file-img-icon" style={{ backgroundImage: `url(${file.tmb})` }}></div>
        );
    } 

    if (!file.tmb && file.icon) {
        return (
            <div className="file-img-icon" style={{ backgroundImage: `url(${file.icon})` }}></div>
        );
    } 
   
    return (
        <span className="file-icon">
            <em className="la la-file"></em>
        </span>
    );
    
}

export const isImageFile = (file) => {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg'];
    return imageExtensions.some(extension => file.name.toLowerCase().endsWith(extension));
};

export const openFileInNewTab = (file, download) => {
    const link = document.createElement('a');
    link.href = file.url;
    link.target = '_blank';
    if(download) {
        link.download = file.name;
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};



export const formatFileSize = (bytes, decimalPoint) => {
    bytes = Number(bytes);
    if (bytes === 0) {
        return '0 Bytes';
    }
    const k = 1000;
    const dm = decimalPoint || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};